import React, {useEffect, useRef} from 'react';
import WizardSteps from "./WizardSteps";
import styles from './WizardStepsWithScroll.module.scss';
import {ReactComponent as ArrowIcon} from "ui-components-rollup/src/images/monochrome-icons/ic-chevron.svg"

const WizardStepsWithScroll = (props) => {
    const scrollableElement = useRef(null);
    const {currentStepIndex} = props;

    useEffect(()=>{
        const element = scrollableElement.current;
        element.scrollLeft = 75 * currentStepIndex;
    },[currentStepIndex]);

    return <div className={styles['base']}>
        <button className={styles['left-button']}
                onClick={() => {
                    const element = scrollableElement.current;
                    element.scrollLeft -= 20;
                }}><ArrowIcon className={styles['left-icon']}/></button>
        <div ref={scrollableElement} className={styles['scrollable-wrapper']}>
            <WizardSteps {...props} className={styles['scrollable']}/>
        </div>
        <button className={styles['right-button']} onClick={() => {
            const element = scrollableElement.current;
            element.scrollLeft += 20;
        }}><ArrowIcon className={styles['right-icon']}/></button>
    </div>
}

export default WizardStepsWithScroll;